import React from 'react';
import { Card } from '@/components/ui';
import { Clock } from 'lucide-react';

export function RecentApprovalActivity() {
  const activities = [
    { title: 'Chờ duyệt: Đề xuất mua vật tư tháng 5', area: 'Ban Vật tư', time: '15 phút trước', type: 'pending' },
    { title: 'Từ chối: Xin nghỉ phép anh Nguyễn Văn A', area: 'Phòng Kỹ thuật', time: '2 giờ trước', type: 'rejected' },
    { title: 'Đã duyệt: Hồ sơ thanh toán Đợt 2', area: 'Nhà thầu XYZ', time: 'Hôm qua, 15:30', type: 'approved' },
    { title: 'Chuyển bước: Tờ trình bổ sung ngân sách', area: 'Ban Giám đốc', time: '12/05/2026', type: 'forwarded' }
  ];

  return (
    <Card className="bg-white border-2 border-slate-100 shadow-sm rounded-md p-5 h-full flex flex-col">
      <div className="flex-1 relative">
        {/* Vertical Line */}
        <div className="absolute top-6 bottom-6 left-[9px] w-[2px] bg-slate-100" />

        <div className="space-y-4 relative z-10">
          {activities.slice(0, 4).map((activity, i) => (
            <div key={i} className="flex items-start gap-4">
              {/* Timeline dot */}
              <div className={`flex-shrink-0 mt-3 flex items-center justify-center w-5 h-5 rounded-full bg-white border-[3px] shadow-[0_0_0_4px_white] ${
                activity.type === 'pending' ? 'border-amber-500' :
                activity.type === 'approved' ? 'border-emerald-500' :
                activity.type === 'rejected' ? 'border-red-500' : 'border-blue-500'
              }`}>
              </div>

              {/* Task Card */}
              <div className={`flex-1 p-3.5 rounded-xl border border-slate-100 bg-white shadow-sm hover:shadow-md transition-all ${
                activity.type === 'pending' ? 'hover:border-amber-200' :
                activity.type === 'approved' ? 'hover:border-emerald-200' :
                activity.type === 'rejected' ? 'hover:border-red-200' : 'hover:border-blue-200'
              }`}>
                <h4 className="text-sm font-black text-slate-800 mb-1.5">{activity.title}</h4>
                <p className="text-xs text-slate-500 mb-2.5">{activity.area}</p>
                <div className="inline-flex items-center gap-1.5 px-2 py-1 rounded-md bg-slate-50 text-slate-500 text-xs font-medium border border-slate-100">
                  <Clock className="w-3.5 h-3.5 opacity-70" />
                  <span>{activity.time}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </Card>
  );
}
